import Services from '../../services';

export default class userLogin extends Services {
  //
}